<template>
  <div class="publicBuy">
    <div class="safe">
      <div class="buyBox">
        <div class="title">
          购买联合会员·{{cardInfo.cardType == '1' ? '月卡' : '年卡'}}
        </div>
        <div class="price">
          &yen;{{this.$COMMON.isIOS ? cardInfo.iosPrice : cardInfo.price}}
        </div>
        <div class="card card1">
          <div class="cardName">
            中国体育超级会员·{{cardInfo.cardType == '1' ? '月卡' : '年卡'}}
          </div>
          <div class="cardBox">
            <div class="logo">
              <img :src="userHeaderImg" @error="defImg" alt="">
            </div>
            <div class="countInfo">
              <div class="word">
                开通账号
              </div>
              <div class="count">
                {{infoData.user.userName}}
              </div>
            </div>
          </div>
        </div>
        <div class="card card2">
          <div class="cardName">
            央视体育VIP·{{cardInfo.cardType == '1' ? '月卡' : '年卡'}}
          </div>
          <div class="cardBox">
            <div class="logo">
              <img src="https://images.zhibo.tv/2021/0601/cctv_logo.png" alt="">
            </div>
            <div class="countInfo">
              <div class="word">
                开通账号
              </div>
              <div class="count">
                {{conductMobile(infoData.user.userMobile)}}
              </div>
            </div>
          </div>
        </div>
        <p class="hint_message">请确认账户信息无误，购买成功后不支持退款或更换账号</p>
        <div class="btn" @click="handleBtn">
          {{$COMMON.isIOS ? "马上开通" : '确认购买'}}
        </div>
        <!-- 关闭按钮 -->
        <div class="icon_close" @click="doClose">
          <img src="https://images.zhibo.tv/2021/0521/icon_cancel@3x.png" alt="">
        </div>
        <!-- <publicpay :payinfo="payinfo" @changePayDialogShow='showPayDialog' v-show="payDialogIsShow" :payDialogIsShow='payDialogIsShow'></publicpay> -->
      </div>
    </div>
    <span class="toast" v-if="toastIsShow">{{toastInfo}}</span>
  </div>
</template>

<script>
export default {
  props: [ 'buyDialogIsShow', 'infoData', 'cardInfo', 'token'],
  name: '',
  data () {
    return {
      isShow: this.buyDialogIsShow,
      // 支付弹窗
      payDialogIsShow: false,
      userHeaderImg: this.infoData.user.userHeadImg ? this.infoData.user.userHeadImg : '',
      toastIsShow: false,
      toastInfo: '',
      payinfo: { price: '23.00', name: '央视体育VIP+中国体育联合会员·月卡', paytype: [{ icon: 'https://images.zhibo.tv/2020/0604/favicon.ico', name: '支付宝' }] },
    }
  },
  computed: {
  },
  watch: {
    isShow (val) {
      this.buyDialogIsShow = val;
    }
  },
  created () {
  },
  methods: {
    // 点击确认(购买/兑换)
    handleBtn () {
      // 购买
      if (this.$COMMON.isIOS) {
        // 关闭确认弹窗
        // this.$emit('changeBuyDialogShow', false);
        this.iosPay()
      } else {
        // 关闭确认弹窗
        this.$emit('changeBuyDialogShow', false);
        // 打开支付弹窗
        this.$emit('changePayDialogShow', true);
        // 展示支付弹窗
        this.showPayDialog(true)
      }
    },
    // 监听图片破损展示默认图片
    defImg(e) {
      e.target.setAttribute('src', 'https://images.zhibo.tv/2020/0409/defhead.png')
    },
    // ios支付
    async iosPay() {
      // 关闭确认弹窗
      this.$emit('changeBuyDialogShow', false);
      try {
        window.webkit.messageHandlers.paymentWithProduct.postMessage({ 'productId': this.cardInfo.iosProductId, 'vipId': this.infoData.id, 'productType': '1', 'union': '1' });
        return;
      } catch (error) {
        console.log('error', { 'productId': this.cardInfo.iosProductId, 'vipId': this.infoData.id });
      }
      // let params = 'token=' + this.token + '&productId=' + this.cardInfo.iosProductId
      // const { data } = await this.$api.getPayIos(params)
      // if ( data.status === '200') {
      //   // 关闭确认弹窗
      //   this.$emit('changeBuyDialogShow', false);
      //   try {
      //     window.webkit.messageHandlers.paymentWithProduct.postMessage({ 'productId': this.cardInfo.iosProductId, 'vipId': this.infoData.id, 'productType': '1', 'union': '1' });
      //     return;
      //   } catch (error) {
      //     console.log('error', { 'productId': this.cardInfo.iosProductId, 'vipId': this.infoData.id });
      //   }
      // } else {
      //   this.showToast(data.data)
      // }
    },
    // 控制是否展示支付弹窗
    showPayDialog (visible) {
      this.payDialogIsShow = visible
    },
    // 关闭
    doClose () {
      // 触发父组件中的dialogVisibleEvent事件，并传递参数
      this.$emit('changeBuyDialogShow', false);
    },
    // toast提示
    showToast(val) {
      this.toastInfo = val
      this.toastIsShow = true
      setTimeout(() => {
        this.toastIsShow = false
      }, 2000)
    },
    // 处理手机格式
    conductMobile(val) {
      let reg = /1(\d{2})\d{4}(\d{4})/g;
      return val && val.length > 0 ? val.replace(reg, "1$1****$2") : val
    }
  }
}
</script>

<style lang='less' scoped>
.publicBuy {
  // display: none;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  // padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
  // padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
  .safe {
    position: absolute;
    left: 0;
    bottom: 0;
    background: #ffffff;
    border-radius: .24rem .24rem 0px 0px;
    // margin-bottom: 84px !important;
    padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
    padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
  }

  .buyBox {
    // margin-bottom: 1rem;
    width: 7.5rem;
    padding: 0.4rem 0.32rem 0.16rem 0.32rem;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 0.24rem 0.24rem 0 0;

    display: flex;
    align-items: center;
    flex-direction: column;

    .title {
      margin-bottom: 0.3rem;
      font-size: 0.34rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 0.48rem;
    }
    .price {
      margin-top: 0.08rem;
      margin-bottom: 0.04rem;
      font-size: 0.88rem;
      font-family: BebasNeue;
      color: #222222;
      line-height: 1.24rem;
    }
    .card {
      // margin-top: 0.3rem;
      margin-bottom: 0.4rem;
      .cardName {
        margin-left: 0.04rem;
        margin-bottom: 0.12rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.4rem;
      }
      .cardBox {
        display: flex;
        justify-content: space-between;
        width: 6.86rem;
        height: 1.24rem;
        background: #f7f7f7;
        border-radius: 0.2rem;
        box-sizing: border-box;
        padding: 0.12rem 0.2rem 0.12rem 0.12rem;
        .logo {
          width: .84rem;
          height: .84rem;
          border-radius: 50%;
          overflow: hidden;
          background: #3a3a3c;
          margin: .08rem 0 .08rem .08rem;
          img {
            width: .84rem;
            height: .84rem;
            border-radius: 50%;
            display: block;
            object-fit: contain;
          }
        }
        .countInfo {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: space-between;
          margin: 0.11rem 0 0.13rem 0;
          .word {
            font-size: 0.24rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 0.32rem;
          }
          .count {
            font-size: 0.24rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 0.32rem;
          }
        }
      }
    }
    .card1 {
      margin-top: 0.3rem;
      .logo {
        background: #f7f7f7!important;
      }
    }
    .card2 .logo {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: .58rem!important;
      }
    }
    .hint_message {
      font-size: .24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: .32rem;
    }
    .btn {
      width: 6.9rem;
      height: 0.88rem;
      margin-top: .44rem;
      margin-bottom: 0.2rem;
      background: url('../assets/icon/btns@2x.png') no-repeat center;
      background-size: 100%;
      text-align: center;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #984b26;
      line-height: 0.88rem;
    }
    .exchangeDesc {
      font-size: 0.2rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 0.28rem;
      padding-bottom: constant(safe-area-inset-bottom); //兼容IOS < 11.2
      padding-bottom: env(safe-area-inset-bottom); //兼容IOS > 11.2
    }
    .icon_close {
      position: absolute;
      width: 0.32rem;
      height: 0.32rem;
      right: 0.32rem;
      top: 0.32rem;
      img {
        display: block;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  .toast {
    z-index: 30;
    display: inline-block;
    white-space: nowrap;
    height: 20px;
    position: fixed;
    margin: auto;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.8);
    border-radius: 4px;
    padding: 10px 20px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: rgba(255, 255, 255, 1);
    text-align: center;
  }
}
@supports (bottom: env(safe-area-inset-bottom)){
  body
  {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>
